<template>
  <!-- Content Header (Page header) -->
  <div v-if="halamanloading" style="height: 100%;width: 100%; background-color: black;position:absolute;z-index: 1000;
  left: 0;top: 0;opacity: 0.75; align-content: center;color: aliceblue;text-align: center;vertical-align: middle;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);background-position: center center;">
    <h1>
      <br><br><br><br><br>
      <img class="animation__shake" src="../../assets/img/logo_pu.jpg" style="height: 70px;position: center center;">
      <br><br>.. LOADING ..
    </h1>
  </div>
  <div class="content-header">
    <div class="container-fluid">
      <div class="col-md-12 text-justify">
        &nbsp;
      </div>
      <div class="row mb-2">
        <div class="col-sm-6">
          <h3><a href="/AWPMapping">Mapping AWP vs DIPA Per Balai Per Proyek </a></h3>
        </div>
        <!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item active"><a href="#"><v-text-field label="Label"
                  class="form-control form-control-sm" aria-disabled="true"> Tanggal {{
                    G_formatDate(tanggalsekarang)
                  }}</v-text-field></a>
            </li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-justify">
          <div class="card card-warning collapsed-card">
            <div class="card-header">
              <h3 class="card-title">Filter Data</h3>

              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                </button>
              </div>
              <!-- /.card-tools -->
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="carddataputih">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <label style="font-size: small;">Balai</label>
                      <v-select :options="balai" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedBalai" @update:modelValue="onBalaiChange"></v-select>
                    </div>
                    <div class="col-lg-6">
                      <label style="font-size: small;">Satker</label>
                      <v-select :options="satker" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedSatker" @update:modelValue="onSatkerChange"></v-select>
                    </div>
                    <div class="col-lg-10">
                      <label style="font-size: small;">Proyek</label>
                      <v-select :options="computeditemsDataProyek" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedProyek" @update:modelValue="onProyekChange"></v-select>
                    </div>
                    <div class="col-lg-2">
                      <label style="font-size: small;">Pilihan Tahun</label>
                      <v-select :options="tahun" :reduce="(label) => label.code" label="label"
                        v-model="defaultSelectedTahun" @update:modelValue="onTahunChange"></v-select>
                    </div>
                    <div class="col-md-12 text-justify">&nbsp;</div>
                  </div>
                  <!-- /.row -->
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.cardputih -->
            </div>
            <!-- /.card-body -->
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-justify">
          <div class="card card-pupr collapsed-card">
            <div class="card-header">
              <h3 class="card-title">Show / Hide Kolom</h3>
              <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div class="cardputih">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-2 col-6">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                          id="customCheckboxTarget" value="optionTarget" @click="showColumnTarget = !showColumnTarget">
                        <label for="customCheckboxTarget" class="custom-control-label">Target Output</label>
                      </div>
                    </div>
                    <div class="col-lg-2 col-6" style="display: none;">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input custom-control-input-success" type="checkbox"
                          id="customCheckboxProyek" value="optionProyek" @click="showColumnProyek = !showColumnProyek">
                        <label for="customCheckboxProyek" class="custom-control-label">Nama Proyek</label>
                      </div>
                    </div>
                    <div class="col-lg-2 col-6">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input custom-control-input-danger" type="checkbox"
                          id="customCheckboxMapping" value="optionMapping"
                          @click="showColumnMapping = !showColumnMapping">
                        <label for="customCheckboxMapping" class="custom-control-label">Sudah Mapping</label>
                      </div>
                    </div>
                    <div class="col-lg-2 col-6">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input custom-control-input-warning" type="checkbox"
                          id="customCheckboxBelumMapping" value="optionBelumMapping"
                          @click="showColumnBelumMapping = !showColumnBelumMapping">
                        <label for="customCheckboxBelumMapping" class="custom-control-label">Belum ter-Mapping</label>
                      </div>
                    </div>
                    <div class="col-lg-2 col-6">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input custom-control-input-danger" type="checkbox"
                          id="customCheckboxSisa" value="optioSisa" @click="showColumnSisa = !showColumnSisa">
                        <label for="customCheckboxSisa" class="custom-control-label">Deviasi AWP vs DIPA</label>
                      </div>
                    </div>
                    <div class="col-lg-2 col-6">
                      <div class="btn-group">
                        <button type="button" class="btn btn-success btn-sm" style="width: 100%;">Export</button>
                        <button type="button" class="btn btn-success dropdown-toggle dropdown-icon"
                          data-toggle="dropdown">
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu" role="menu">
                          <a class="dropdown-item" href="#"
                            @click="G_tableCSV('_Detail_Mapping_AWP_vs_DIPA_Tgl_Data_')">Excel</a>
                          <a class="dropdown-item" href="#" @click="printContent()">Print</a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2 col-6">&nbsp;</div>
                    <div class="col-lg-12 col-6">&nbsp;</div>
                    <div class="col-lg-2 col-6">
                      <label style="font-size: small;">Keterangan</label>
                      <div class="col-md-12 text-justify" style="color: #1976d2;">Sudah Mapping</div>
                    </div>
                    <div class="col-lg-2 col-6">
                      <label style="font-size: small;">Keterangan</label>
                      <div class="col-md-12 text-justify" style="color: #f14245;">Belum Mapping</div>
                    </div>
                  </div>
                  <!-- /.row -->
                </div>
                <!-- /.card-body -->
              </div>
              <!-- /.cardputih -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-justify">
          <div class="cardputih">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-4 text-justify"></div>
                <div class="col-sm-4 text-center">
                  <v-text-field label="Label" class="form-control form-control-sm" aria-disabled="true" style="background-color: #354777;
                  color:#ffffff;font-size: smaller;border-top-left-radius: 50px;border-bottom-left-radius: 50px;
                  border-top-right-radius: 50px;border-bottom-right-radius: 50px;
                  border-left: #ffc107 solid 20px;border-right: #ffc107 solid 20px;"> Tanggal Data: {{
                    G_formatDate(tanggaldata)
                  }}</v-text-field>
                </div>
                <div class="col-sm-4 text-justify"></div>
                <div class="col-sm-12 text-justify">&nbsp;</div>
                <div class="col-sm-1 text-justify">
                  <label style="font-size: small;">Pencarian</label>
                </div>
                <div class="col-sm-11 text-justify">
                  <input type="text" v-model="carikata" class="form-control form-control-sm"
                    placeholder="Masukkan Kata Kunci Pencarian">
                </div>
                <div class="col-md-12 text-justify">&nbsp;</div>
              </div>
              <div class="table-wrapper">
                <table class="table table table-bordered table-hover" id="tabeldata">
                  <thead class="cf">
                    <tr>
                      <th style="width: 70px;">No</th>
                      <th style="width: 250px;" v-if="showColumnProyek">Kode</th>
                      <th style="width: 420px;">Kode<br>Kegiatan AWP <br>/ Nama Paket</th>
                      <th style="width: 100px;" v-if="showColumnTarget">Target<br>Output</th>
                      <th style="width: 250px;" v-if="showColumnProyek">Nama<br>Proyek</th>
                      <th style="width: 80px;">AWP<br>(Rp.)</th>
                      <th v-if="showColumnMapping">DIPA Sudah<br>Mapping<br>(Rp.)</th>
                      <th v-if="showColumnBelumMapping">DIPA Belum<br>Ter-Mapping<br>(Rp.)</th>
                      <th style="width: 80px;">Total DIPA<br>(Rp.)</th>
                      <th v-if="showColumnSisa">Deviasi<br>AWP vs DIPA<br>(Rp.)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="total">TOTAL</td>
                      <td class="total" v-if="showColumnProyek"></td>
                      <td class="total"></td>
                      <td class="total" v-if="showColumnTarget"></td>
                      <td class="total" v-if="showColumnProyek"></td>
                      <td class="totalkanan">{{ G_numFormat(totalawp) }}</td>
                      <td class="totalkanan" v-if="showColumnMapping">{{ G_numFormat(totalmappedPg) }}</td>
                      <td class="totalkanan" v-if="showColumnBelumMapping">{{ G_numFormat(totalunMappedPg) }}</td>
                      <td class="totalkanan">{{ G_numFormat(totalpg) }}</td>
                      <td class="totalkanan" v-if="showColumnSisa">{{ G_numFormat(totalremainingAwp) }}</td>
                    </tr>
                    <tr v-for="(dataparent, urutparent) in filteredKata" :key="urutparent">
                      <td style="width: 70px;" :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatker' :
                                dataparent.Class == 'kolomdata' ? 'kolomdata' : 'kolomdatasudah'))]">
                        {{ dataparent.No }}
                      </td>
                      <td style="width: 250px;" :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatker' :
                                dataparent.Class == 'kolomdata' ? 'kolomdata' : 'kolomdatasudah'))]"
                        v-if="showColumnProyek">
                        {{ dataparent.Kode }}
                      </td>
                      <td style="width: 250px;" :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatker' :
                                dataparent.Class == 'kolomdata' ? 'kolomdata' : 'kolomdatasudah'))]">
                        <span v-if="dataparent.Kode.length > 1">{{ dataparent.Kode }}<br></span>{{ dataparent.Kegiatan
                        }}<br><i>{{ dataparent.NamaProyek }}</i>
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatker' :
                                dataparent.Class == 'kolomdata' ? 'kolomdata' : 'kolomdatasudah'))]"
                        v-if="showColumnTarget">
                        {{ dataparent.Target }}
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusat' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektorat' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutput' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatker' :
                                dataparent.Class == 'kolomdata' ? 'kolomdata' : 'kolomdatasudah'))]"
                        v-if="showColumnProyek">
                        {{ dataparent.NamaProyek }}
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatkerkanan' :
                                dataparent.Class == 'kolomdata' ? 'kolomdatakanan' : 'kolomdatasudahkanan'))]">
                        {{ dataparent.Alokasi }}
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatkerkanan' :
                                dataparent.Class == 'kolomdata' ? 'kolomdatakanan' : 'kolomdatasudahkanan'))]"
                        v-if="showColumnMapping">
                        {{ dataparent.mappedPg }}
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatkerkanan' :
                                dataparent.Class == 'kolomdata' ? 'kolomdatakanan' : 'kolomdatasudahkanan'))]"
                        v-if="showColumnBelumMapping">
                        {{ dataparent.unMappedPg }}
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatkerkanan' :
                                dataparent.Class == 'kolomdata' ? 'kolomdatakanan' : 'kolomdatasudahkanan'))]">
                        {{ dataparent.pg }}
                      </td>
                      <td :class="[(dataparent.Class == 'kolompusat' ? 'kolompusatkanan' :
                        (dataparent.Class == 'kolomdirektorat' ? 'kolomdirektoratkanan' :
                          dataparent.Class == 'kolomkegiatan' ? 'kolomkegiatankanan' :
                            dataparent.Class == 'kolomoutput' ? 'kolomoutputkanan' :
                              dataparent.Class == 'kolomsatker' ? 'kolomsatkerkanan' :
                                dataparent.Class == 'kolomdata' ? 'kolomdatakanan' : 'kolomdatasudahkanan'))]"
                        v-if="showColumnSisa">
                        {{ dataparent.remainingAwp }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">&nbsp;</div>
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content -->
</template>
    
<script>
import $ from 'jquery';
import axios from "axios";
//import Vueaxios from "vue-axios";
import vSelect from 'vue-select';
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css";
//import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import xlsx from 'xlsx/dist/xlsx.full.min';
//import { Doughnut } from "vue-chartjs";
//import Chart from 'chart.js'

export default {
  components: {
    vSelect
  },
  data() {
    return {
      carikata: '',
      cekbalai: [],
      showColumnTarget: false,
      showColumnProyek: false,
      showColumnMapping: false,
      showColumnBelumMapping: false,
      showColumnSisa: false,
      halamanloading: true,
      defaultSelectedProyek: {
        code: "0",
        label: "Semua Proyek",
        tag: "Semua Proyek"
      },
      kdProyekfilter: "",
      datamasterProyek: [],
      Proyek: [],

      defaultSelectedBalai: {
        code: "0",
        label: "Semua Balai"
      },
      kdbalaifilter: "",
      datamasterbalai: [],
      balai: [],

      defaultSelectedSatker: {
        code: "0",
        label: "Semua Satker"
      },
      kdsatkerfilter: "",
      datamastersatker: [],
      satker: [],

      defaultSelectedTahun: {
        code: 0,
        label: localStorage.getItem("TahunAktif"),
      },
      tahunfilter: localStorage.getItem("TahunAktif"),
      tanggaldata: new Date(),
      tanggalpmis: new Date(),
      datatahun: [],
      tahun: [],
      selectedIsi: '',
      selectedtahun: localStorage.getItem("TahunAktif"),
      ///// rekap
      datarekap: [],
      datamapping: [],
      tabelmapping: [],
      datatabelmapping: [],
      tabelpmis: [],

      totalawp: 0,
      totalmappedPg: 0,
      totalunMappedPg: 0,
      totalremainingAwp: 0,
      totalpg: 0,

      framework: [],
      tanggalsekarang: new Date(),
    }
  },
  computed: {
    computeditemsDataProyek: function () {
      return this.Proyek.filter(function (item) {
        return item.label != "TEST-Test Edit";
      })
    },
    filteredKata() {
      const filteredWorkers = this.carikata === ""
        ? this.datatabelmapping
        : this.datatabelmapping.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
      return filteredWorkers;
    },
  },
  methods: {
    printContent() {
      var divToPrint = document.getElementById('tabeldata');
      var htmlToPrint = '' +
        '<style type="text/css">' +
        'table th, table td {' +
        'border:1px solid #000;' +
        '}' +
        '</style>';
      htmlToPrint += divToPrint.outerHTML;
      const printWindow = window.open('', '', 'height=1000,width=1000')
      printWindow.document.write(htmlToPrint)
      printWindow.print()

    },
    async G_tableCSV(namefile) {
      this.framework = [];
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIRekap = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIRekap.get("awp/detail?tahun=" + this.tahunfilter + "&hasProyekOnly=true&hasSbsnOnly=false&proyek="
        + this.kdProyekfilter + "&kdbalai=" + this.kdbalaifilter + "&kdsatker=" + this.kdsatkerfilter)
        .then(
          Response => {
            this.tabelmapping = Response.data.content;
            this.tanggaldata = Response.data.tanggalEmon;
            this.totalawp = this.tabelmapping.reduce((a, { awp: e }) => a + e, 0);
            this.totalmappedPg = this.tabelmapping.reduce((a, { mappedPg: e }) => a + e, 0);
            this.totalunMappedPg = this.tabelmapping.reduce((a, { unMappedPg: e }) => a + e, 0);
            this.totalremainingAwp = this.tabelmapping.reduce((a, { remainingAwp: e }) => a + e, 0);
            this.totalpg = this.tabelmapping.reduce((a, { pg: e }) => a + e, 0);

            this.framework.push({
              "No": "",
              "Kode": "TOTAL",
              "Kegiatan": "",
              "Target": "",
              "NamaProyek": "",
              "Alokasi": this.totalawp,
              "mappedPg": this.totalmappedPg,
              "unMappedPg": this.totalunMappedPg,
              "pg": this.totalpg,
              "remainingAwp": this.totalremainingAwp,

            })

            for (let i = 0; i < this.tabelmapping.length; i++) {
              if (this.tabelmapping[i].pg) {
                this.framework.push({
                  "No": (i + 1),
                  "Kode": this.tabelmapping[i].projekNm || '',
                  "Kegiatan": "",
                  "Target": "",
                  "NamaProyek": "",
                  "Alokasi": this.tabelmapping[i].awp,
                  "mappedPg": this.tabelmapping[i].mappedPg,
                  "unMappedPg": this.tabelmapping[i].unMappedPg,
                  "pg": this.tabelmapping[i].pg,
                  "remainingAwp": this.tabelmapping[i].remainingAwp,

                })
                for (let z = 0; z < this.tabelmapping[i].rekapPerBalais.length; z++) {
                  if (this.tabelmapping[i].rekapPerBalais[z].pg) {
                    this.framework.push({
                      "No": (i + 1) + "." + (z + 1),
                      "Kode": this.tabelmapping[i].rekapPerBalais[z].nmbalai || '',
                      "Kegiatan": "",
                      "Target": "",
                      "NamaProyek": "",
                      "Alokasi": this.tabelmapping[i].rekapPerBalais[z].awp,
                      "mappedPg": this.tabelmapping[i].rekapPerBalais[z].mappedPg,
                      "unMappedPg": this.tabelmapping[i].rekapPerBalais[z].unMappedPg,
                      "pg": this.tabelmapping[i].rekapPerBalais[z].pg,
                      "remainingAwp": this.tabelmapping[i].rekapPerBalais[z].awp - this.tabelmapping[i].rekapPerBalais[z].pg,

                    })
                    for (let c = 0; c < this.tabelmapping[i].rekapPerBalais[z].kegiatans.length; c++) {
                      if (this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].pagu) {
                        this.framework.push({
                          "No": (i + 1) + "." + (z + 1) + "." + (c + 1),
                          "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].kodeKegiatan || '',
                          "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].namaKegiatan || '',
                          "Target": "",
                          "NamaProyek": "",
                          "Alokasi": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].anggaranAwp,
                          "mappedPg": "",
                          "unMappedPg": "",
                          "pg": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].pagu,
                          "remainingAwp": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].anggaranAwp - this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].pagu,

                        })
                        for (let x = 0; x < this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs.length; x++) {
                          this.framework.push({
                            "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1),
                            "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].kodeKegiatan || '',
                            "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].namaKegiatan || '',
                            "Target": "",
                            "NamaProyek": "",
                            "Alokasi": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].anggaranAwp,
                            "mappedPg": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].pagu,
                            "unMappedPg": "",
                            "pg": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].pagu,
                            "remainingAwp": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].anggaranAwp - this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].pagu,

                          })
                          for (let y = 0; y < this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs.length; y++) {
                            this.framework.push({
                              "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1) + "." + (y + 1),
                              "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].kodeKegiatan || '',
                              "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].namaKegiatan || '',
                              "Target": "",
                              "NamaProyek": "",
                              "Alokasi": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].anggaranAwp,
                              "mappedPg": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pagu,
                              "unMappedPg": "",
                              "pg": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pagu,
                              "remainingAwp": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].anggaranAwp - this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pagu,

                            })
                            try {
                              console.log(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets.length);
                              for (let s = 0; s < this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets.length; s++) {
                                try {
                                  this.framework.push({
                                    "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1) + "." + (y + 1) + "." + (s + 1),
                                    "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].kode || '',
                                    "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].nmgiat || '',
                                    "Target": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].vol + ' ' + this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].sat,
                                    "NamaProyek": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].nmpaket || '',
                                    "Alokasi": "",
                                    "mappedPg": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].pg,
                                    "unMappedPg": "",
                                    "pg": "",
                                    "remainingAwp": "",

                                  })
                                }
                                catch {
                                  console.log('no data');
                                }
                              }
                            }
                            catch {
                              console.log('no data');
                            }
                          }
                        }
                      }
                    }
                    for (let m = 0; m < this.tabelmapping[i].rekapPerBalais[z].unmappedPakets.length; m++) {
                      if (this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].pg) {
                        this.framework.push({
                          "No": (m + 1),
                          "Kode": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].kode || '',
                          "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].nmgiat || '',
                          "Target": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].vol + ' ' + this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].sat,
                          "NamaProyek": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].nmpaket || '',
                          "Alokasi": "",
                          "mappedPg": "",
                          "unMappedPg": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].pg,
                          "pg": "",
                          "remainingAwp": "",

                        })
                      }
                    }
                  }
                }
              }
            }
            function formatColumn(worksheet, col, fmt) {
              const range = XLSX.utils.decode_range(worksheet['!ref'])
              // note: range.s.r + 1 skips the header row
              for (let row = range.s.r + 1; row <= range.e.r; ++row) {
                const ref = XLSX.utils.encode_cell({ r: row, c: col })
                if (worksheet[ref] && worksheet[ref].t === 'n') {
                  worksheet[ref].z = fmt
                }
              }
            }
            const currency = '0.00';

            const XLSX = xlsx;
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(this.framework);

            for (let col of [4, 5, 6, 7, 8, 9]) {
              formatColumn(worksheet, col, currency)
            }

            XLSX.utils.book_append_sheet(workbook, worksheet, "framework");
            XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + this.G_formatDate(this.tanggaldata) + ".xlsx");
            this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
      this.halamanloading = false;
    },
    onProyekChange(a) {
      this.selectedIsi = this.Proyek[a].tag;
      let filter = this.selectedIsi;
      this.kdProyekfilter = "";
      if (filter != 'Semua Proyek') { this.kdProyekfilter = filter }
      this.ambildataUpdate();
    },
    onTahunChange(a) {
      this.selectedtahun = this.tahun[a].label;
      this.tahunfilter = this.selectedtahun;
      this.ambildataUpdate();
    },
    onBalaiChange(a) {
      let selectedIsi = this.balai[a].code;
      this.kdbalaifilter = "";
      if (selectedIsi != 0) { this.kdbalaifilter = selectedIsi }
      this.AmbilDataSatker();
      //console.log(selectedIsi);
      this.ambildataUpdate();
    },
    onSatkerChange(a) {
      let selectedIsi = this.satker[a].tag;
      this.kdsatkerfilter = "";
      if (selectedIsi != 0) { this.kdsatkerfilter = selectedIsi }
      //console.log(selectedIsi);
      this.ambildataUpdate();
    },
    async ambildataUpdate() {
      this.halamanloading = true;
      await this.AmbilDataRekap();
    },
    initializeSelect2() {
      //Initialize Select2 Elements
      $(".select2").select2();

      //Initialize Select2 Elements
      $(".select2bs4").select2({
        theme: "bootstrap4",
      });
    },
    async AmbilDataBalai() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      this.cekbalai = JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/balai")
        .then(
          Response => {
            //console.log(Response.data);
            this.datamasterbalai = Response.data.content;
            //console.log(this.datamasterdonor);
            this.datamasterbalai.forEach((item) => {
              this.balai.push({
                label: item.nmbalai,
                code: item.kdbalai,
              });
            });
            if (this.cekbalai.kdbalai == null) {
              this.balai.unshift({
                label: 'Semua Balai',
                code: '0',
              });
            }
            else {
              this.defaultSelectedBalai = this.balai;
              //this.selectedbalai = this.balai[0].label;
              this.kdbalaifilter = this.balai[0].code;
              //console.log("Balai"+this.selectedbalai);
            }
            //console.log(this.donor);

          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          window.location.replace("/");
        })
    },
    async AmbilDataSatker() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/satker?kdbalai=" + this.kdbalaifilter)
        .then(
          Response => {
            //console.log(Response.data);
            this.satker = [];
            this.datamastersatker = Response.data.content;
            //console.log(this.datamasterdonor);
            this.datamastersatker.forEach((item) => {
              this.satker.push({
                label: item.satkerNm,
                code: this.datamastersatker.indexOf(item) + 1,
                tag: item.satkerId,
              });
            });
            this.satker.unshift({
              label: 'Semua Satker',
              code: '0',
              tag: '0',
            });
            //console.log(this.donor);

          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        })
    },
    async AmbilDataProyek() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIMaster = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIMaster.get("reff/proyek")
        .then(
          Response => {
            //console.log(Response.data);
            this.datamasterProyek = Response.data.content;
            //console.log(this.datamasterProyek);
            this.datamasterProyek.forEach((item) => {
              this.Proyek.push({
                label: item.projekId + '-' + item.projekNm,
                code: this.datamasterProyek.indexOf(item) + 1,
                tag: item.projekId,
              });
            });
            this.Proyek.unshift({
              label: 'Semua Proyek',
              code: '0',
              tag: 'Semua Proyek',
            });
            //console.log(this.Proyek);
            //this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          window.location.replace("/");
        })
    },
    async AmbilDataTahun() {
      this.halamanloading = true;
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPITahun = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPITahun.get("progres/tahun")
        .then(
          Response => {
            this.datatahun = Response.data.content;
            //console.log(this.datatahun);
            //this.selected = document.getElementById('pilihantahun').options[0].text;
            this.datatahun.forEach((item) => {
              this.tahun.push({
                label: item,
                code: this.datatahun.indexOf(item),
              });
            });
            //this.halamanloading = false;
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
    async AmbilDataRekap() {
      this.halamanloading = true;
      //await this.AmbilDataBalai();
      JSON.parse(localStorage.getItem("userLogin"));
      const mainAPIRekap = axios.create({
        baseURL: process.env.VUE_APP_URL_API,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      await mainAPIRekap.get("awp/detail?tahun=" + this.tahunfilter + "&hasProyekOnly=true&hasSbsnOnly=false&proyek="
        + this.kdProyekfilter + "&kdbalai=" + this.kdbalaifilter + "&kdsatker=" + this.kdsatkerfilter)
        .then(
          Response => {
            this.tabelmapping = Response.data.content;
            this.tanggaldata = Response.data.tanggalEmon;
            this.totalawp = this.tabelmapping.reduce((a, { awp: e }) => a + e, 0);
            this.totalmappedPg = this.tabelmapping.reduce((a, { mappedPg: e }) => a + e, 0);
            this.totalunMappedPg = this.tabelmapping.reduce((a, { unMappedPg: e }) => a + e, 0);
            this.totalremainingAwp = this.tabelmapping.reduce((a, { remainingAwp: e }) => a + e, 0);
            this.totalpg = this.tabelmapping.reduce((a, { pg: e }) => a + e, 0);
            this.LoadTabelDataMapping();
          }
        ).catch(error => {
          console.log(error);
          this.halamanloading = false;
          //window.location.replace("/");
        });
    },
    LoadTabelDataMapping() {
      this.halamanloading = true;
      this.datatabelmapping = [];
      for (let i = 0; i < this.tabelmapping.length; i++) {
        if (this.tabelmapping[i].pg) {
          this.datatabelmapping.push({
            "No": (i + 1),
            "Kode": this.tabelmapping[i].projekNm || '',
            "Kegiatan": "",
            "Target": "",
            "NamaProyek": "",
            "Alokasi": this.G_numFormat(this.tabelmapping[i].awp),
            "mappedPg": this.G_numFormat(this.tabelmapping[i].mappedPg),
            "unMappedPg": this.G_numFormat(this.tabelmapping[i].unMappedPg),
            "pg": this.G_numFormat(this.tabelmapping[i].pg) || 0,
            "remainingAwp": this.G_numFormat(this.tabelmapping[i].remainingAwp),
            "Class": "kolompusat",
          })
          for (let z = 0; z < this.tabelmapping[i].rekapPerBalais.length; z++) {
            if (this.tabelmapping[i].rekapPerBalais[z].pg) {
              this.datatabelmapping.push({
                "No": (i + 1) + "." + (z + 1),
                "Kode": this.tabelmapping[i].rekapPerBalais[z].nmbalai || '',
                "Kegiatan": "",
                "Target": "",
                "NamaProyek": "",
                "Alokasi": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].awp),
                "mappedPg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].mappedPg),
                "unMappedPg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].unMappedPg),
                "pg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].pg),
                "remainingAwp": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].awp - this.tabelmapping[i].rekapPerBalais[z].pg),
                "Class": "kolomdirektorat",
              })
              for (let c = 0; c < this.tabelmapping[i].rekapPerBalais[z].kegiatans.length; c++) {
                if (this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].pagu) {
                  this.datatabelmapping.push({
                    "No": (i + 1) + "." + (z + 1) + "." + (c + 1),
                    "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].kodeKegiatan || '',
                    "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].namaKegiatan || '',
                    "Target": "",
                    "NamaProyek": "",
                    "Alokasi": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].anggaranAwp),
                    "mappedPg": "",
                    "unMappedPg": "",
                    "pg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].pagu),
                    "remainingAwp": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].anggaranAwp - this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].pagu),
                    "Class": "kolomkegiatan",
                  })
                  for (let x = 0; x < this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs.length; x++) {
                    this.datatabelmapping.push({
                      "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1),
                      "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].kodeKegiatan || '',
                      "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].namaKegiatan || '',
                      "Target": "",
                      "NamaProyek": "",
                      "Alokasi": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].anggaranAwp),
                      "mappedPg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].pagu),
                      "unMappedPg": "",
                      "pg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].pagu),
                      "remainingAwp": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].anggaranAwp - this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].pagu),
                      "Class": "kolomoutput",
                    })
                    for (let y = 0; y < this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs.length; y++) {
                      this.datatabelmapping.push({
                        "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1) + "." + (y + 1),
                        "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].kodeKegiatan || '',
                        "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].namaKegiatan || '',
                        "Target": "",
                        "NamaProyek": "",
                        "Alokasi": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].anggaranAwp),
                        "mappedPg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pagu),
                        "unMappedPg": "",
                        "pg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pagu),
                        "remainingAwp": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].anggaranAwp - this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pagu),
                        "Class": "kolomsatker",
                      })
                      try {
                        //console.log(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets.length);
                        for (let s = 0; s < this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets.length; s++) {
                          try {
                            this.datatabelmapping.push({
                              "No": (i + 1) + "." + (z + 1) + "." + (c + 1) + "." + (x + 1) + "." + (y + 1) + "." + (s + 1),
                              "Kode": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].kode || '',
                              "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].nmgiat || '',
                              "Target": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].vol + ' ' + this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].sat,
                              "NamaProyek": this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].nmpaket || '',
                              "Alokasi": "",
                              "mappedPg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].kegiatans[c].childs[x].childs[y].pakets[s].pg),
                              "unMappedPg": "",
                              "pg": "",
                              "remainingAwp": "",
                              "Class": "kolomdatasudah",
                            })
                          }
                          catch {
                            console.log('no data');
                          }
                        }
                      }
                      catch {
                        console.log('no data');
                      }
                    }
                  }
                }
              }
              for (let m = 0; m < this.tabelmapping[i].rekapPerBalais[z].unmappedPakets.length; m++) {
                if (this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].pg) {
                  this.datatabelmapping.push({
                    "No": (m + 1),
                    "Kode": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].kode || '',
                    "Kegiatan": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].nmgiat || '',
                    "Target": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].vol + ' ' + this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].sat,
                    "NamaProyek": this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].nmpaket || '',
                    "Alokasi": "",
                    "mappedPg": "",
                    "unMappedPg": this.G_numFormat(this.tabelmapping[i].rekapPerBalais[z].unmappedPakets[m].pg),
                    "pg": "",
                    "remainingAwp": "",
                    "Class": "kolomdata",
                  })
                }
              }
            }
          }
        }
      }
      this.halamanloading = false;
      //console.log(this.datatabelmapping);
    },
  },
  created() {
    this.halamanloading = true;
  },
  beforeMount() {
    this.halamanloading = true;
  },
  mounted() {
    this.initializeSelect2();
    this.AmbilDataProyek();
    this.AmbilDataTahun();
    this.AmbilDataRekap();
    this.AmbilDataBalai();
    this.AmbilDataSatker();
    document.getElementById('DashboardGrup').className = 'nav-item menu-open';
    document.getElementById('MonitoringGrup').className = 'nav-item menu-close';
    document.getElementById('PaketPipeLineGrup').className = 'nav-item menu-close';
    document.getElementById('PaketKontraktualGrup').className = 'nav-item menu-close';
    document.getElementById('PrognosisGrup').className = 'nav-item menu-close';
    document.getElementById('KendalaGrup').className = 'nav-item menu-close';
    document.getElementById('AWPGrup').className = 'nav-item menu-open';
    document.getElementById('PengecekanGrup').className = 'nav-item menu-close';
    document.getElementById('FormIsianGrup').className = 'nav-item menu-close';
    document.getElementById('KompilasiGrup').className = 'nav-item menu-close';
    document.getElementById('ADKGrup').className = 'nav-item menu-close';
    document.getElementById('ManajemenGrup').className = 'nav-item menu-close';
    document.getElementById('bodyLMS').className = 'hold-transition sidebar-mini layout-fixed';
    const sidebar = document.querySelector('aside');
    sidebar.style.display = 'block';
    const nav = document.querySelector('nav');
    nav.style.visibility = 'visible';
    //document.getElementById('Atas').style.visibility = 'visible';
    const footer = document.querySelector('footer');
    footer.style.visibility = 'visible';

  },
};
</script>
    
<style></style>